import { IWorkflowComment } from 'typings/manager';

export class WorkflowComment implements IWorkflowComment {
    reviewerDisplayName: string;

    type: string;

    comment: string;

    date: string;

    constructor(workflowComment: IWorkflowComment) {
        this.reviewerDisplayName = workflowComment.reviewerDisplayName;
        this.type = workflowComment.type;
        this.comment = workflowComment.comment;
        this.date = workflowComment.date;
    }

    get commentDateType(): Date {
        return new Date(this.date);
    }
}